import { render, staticRenderFns } from "./CatalogStudioAvailability.vue?vue&type=template&id=52d0f31d&scoped=true"
import script from "./CatalogStudioAvailability.vue?vue&type=script&lang=js"
export * from "./CatalogStudioAvailability.vue?vue&type=script&lang=js"
import style0 from "./CatalogStudioAvailability.vue?vue&type=style&index=0&id=52d0f31d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d0f31d",
  null
  
)

export default component.exports